var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cart-items" },
    [
      _c("div", { staticClass: "cart-items__list-wrapper" }, [
        _vm.cart.items.length
          ? _c(
              "ul",
              { staticClass: "cart-items__list" },
              _vm._l(_vm.cart.items, function (item) {
                return _c(
                  "li",
                  { key: item.id },
                  [
                    _c("CartItem", {
                      attrs: { item: item },
                      on: {
                        change: _vm.updateItem,
                        edit: _vm.editItem,
                        delete: _vm.openDeleteModal,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : _c("p", { staticClass: "cart-items__no-items-msg" }, [
              _vm._v("\n      No items in the cart\n    "),
            ]),
      ]),
      _vm._v(" "),
      _c("SheetModal", {
        attrs: { item: _vm.currentItem, "is-open": _vm.sheetModalOpen },
        on: {
          edit: _vm.editItem,
          update: _vm.updateSheet,
          close: _vm.closeSheetModal,
        },
      }),
      _vm._v(" "),
      _c("DeleteModal", {
        attrs: { item: _vm.currentItem, "is-open": _vm.deleteModalOpen },
        on: { delete: _vm.deleteItem, close: _vm.closeDeleteModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }